'use client';
import * as infrastructure from '@/infrastructure';
import { ReactNode, createContext, useContext } from 'react';

export type InfrastructureValue = typeof infrastructure;

export const InfrastructureContext = createContext<InfrastructureValue>(
  null as any
);

export const InfrastructureProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <InfrastructureContext.Provider value={infrastructure}>
      {children}
    </InfrastructureContext.Provider>
  );
};

export const useInfrastructureContext = () => useContext(InfrastructureContext);
